export default {
  user: {},
  token: "",
  logout: false,
};
